<template>
  <b-modal
    ref="modal"
    id="edit-asset-modal"
    title="Modal Variants"
    hide-header
    hide-footer
    centered
    @hide="onHide"
    @show="onShow"
    static
  >
    <div class="right" v-if="isMobile">
      <div class="icon">
        <center>
          <font-awesome-icon @click="() => off()" :icon="faTimes" />
        </center>
      </div>
    </div>
    <div class="header">
      <span>{{ $t('UPDATE_ASSET_DETAIL') }}</span>
    </div>
    <b-container class="body">
      <b-row>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('NAME_CLI')"
            v-model="clientName"
            borderbottom
            disabled
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('CREATED_DATE')"
            v-model="createdAt"
            borderbottom
            disabled
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('LAST_MODIFIED')"
            v-model="modifiedAt"
            borderbottom
            disabled
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('LIQUIDIZED')"
            v-model="liquidizedOn"
            borderbottom
            disabled
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('STORAGE_CODE')"
            v-model="code"
            borderbottom
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <select-input
            v-model="categoryId"
            :items="categories"
            ref="categoryIdInput"
            :label="$t('ASSET_TYPE')"
            borderbottom
            required
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <select-input
            v-model="storage"
            :items="storagesList"
            ref="storageInput"
            :label="$t('STORAGE')"
            borderbottom
            required
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <select-input
            v-model="status"
            :items="statusList"
            ref="assetStatusInput"
            :label="$t('STATUS')"
            borderbottom
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            v-model="valuatedAmount"
            ref="valuatedAmountInput"
            :label="$t('VALUATED_AMOUNT')"
            borderbottom
            required
            class="amount-input"
            :hint="changeDigitToViText(valuatedAmount)"
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            v-model="expectedAmount"
            ref="expectedAmountInput"
            :label="$t('EXPECTED_AMOUNT')"
            borderbottom
            class="amount-input"
            :hint="changeDigitToViText(expectedAmount)"
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <select-input
            :label="$t('VALUATOR')"
            v-model="valuator"
            :items="valuators"
            required
            ref="valuatorInput"
            borderbottom
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('DESCRIPTION')"
            v-model="description"
            textarea
            required
            borderbottom
            ref="descriptionInput"
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="!isRealEstate">
          <text-input
            :label="$t('ACCESSORIES')"
            v-model="accessories"
            borderbottom
            textarea
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="!isRealEstate">
          <text-input
            :label="$t('BRAND')"
            v-model="brand"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="!isRealEstate">
          <text-input
            :label="$t('PRODUCT_LINE')"
            v-model="productLine"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isVehicle">
          <text-input
            :label="$t('CHASSIS_ID')"
            v-model="chassisId"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isVehicle">
          <text-input
            :label="$t('ENGINE_ID')"
            v-model="engineId"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isVehicle">
          <text-input
            :label="$t('COLOR')"
            v-model="color"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isVehicle">
          <text-input
            :label="$t('LICENSE_PLATE_ID')"
            v-model="licensePlateId"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isRealEstate">
          <text-input
            :label="$t('CO_OWNER')"
            v-model="coOwner"
            borderbottom
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-show="isRealEstate">
          <text-input
            :label="$t('CO_OWNER_CITIZEN_ID')"
            v-model="coOwnerCitizenId"
            borderbottom
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="btns">
            <primary-button @click="off()" blue :text="$t('CANCEL')" />
            <primary-button @click="save()" :text="$t('SAVE')" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>
<script>
import { watch, ref, computed, onMounted } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { ASSET_STATUSES, MILLION, DATE_FORMAT } from '@/consts';
import { addCommas, removeCommas, changeDigitToViText } from '@/helpers';

import PrimaryButton from '@/components/PrimaryButton';
import TextInput from '@/components/TextInput';
import SelectInput from '@/components/SelectInput';

const { useGetters: useModalGetters, useActions: useModalActions } = createNamespacedHelpers('modal');
const { useState, useActions } = createNamespacedHelpers('assetsList');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useState: useAppState, useActions: useAppActions } = createNamespacedHelpers('app');

const VEHICLES = [
  'MOTORCYCLE',
  'AUTOMOBILE',
  'TRUCK'
];

const REAL_ESTATE = 'REAL_ESTATE';

export default {
  name: 'EditAssetInfo',
  components: {
    TextInput,
    SelectInput,
    FontAwesomeIcon,
    PrimaryButton
  },

  setup(props, { root }) {
    const { isEditAssetModalActive: isOpen } = useModalGetters(['isEditAssetModalActive']);
    const { toggleEditAssetModal: toggleEditAsset } = useModalActions(['toggleEditAssetModal', 'toggleConfirmModal']);
    const { targetingAsset: asset } = useState(['targetingAsset']);
    const { isMobile, assetCategories, valuators: valuators_, storages } = useAppState(['isMobile', 'assetCategories', 'valuators', 'storages']);
    const { info, error } = useFlashActions(['info', 'error']);
    const { updateAsset, getAssetsList } = useActions(['updateAsset', 'getAssetsList']);
    const { getValuators } = useAppActions(['getValuators']);

    const storagesList = computed(() => storages.value.map((b) => ({
      value: b.id,
      text: b.name
    })));

    const modal = ref(null);
    const storage = ref('');
    const description = ref('');
    const status = ref('');
    const valuatedAmount = ref('');
    const expectedAmount = ref('');
    const categoryId = ref('');
    const valuator = ref(null);
    const meta = ref({});
    const code = ref('');
    const clientName = ref('');
    const liquidizedOn = ref('');
    const createdAt = ref('');
    const modifiedAt = ref('');

    const accessories = ref('');
    const brand = ref('');
    const productLine = ref('');
    const chassisId = ref('');
    const engineId = ref('');
    const color = ref('');
    const licensePlateId = ref('');
    const coOwner = ref('');
    const coOwnerCitizenId = ref('');

    const valuators = computed(() => valuators_.value?.map((item) => ({
      text: `${item.firstName} ${item.lastName} (${item.username})`,
      value: item.id
    })));

    const isVehicle = computed(() => {
      const cat = assetCategories.value.find((c) => c.id === categoryId.value);
      if (!cat) return false;

      return (VEHICLES.indexOf(cat.key) >= 0);
    });

    const isRealEstate = computed(() => {
      const cat = assetCategories.value.find((c) => c.id === categoryId.value);
      if (!cat) return false;

      return (cat.key === REAL_ESTATE);
    });

    const statusList = Object.keys(ASSET_STATUSES).map((item) => ({
      text: root.$t(ASSET_STATUSES[item]),
      value: ASSET_STATUSES[item]
    }));

    const categories = computed(() => assetCategories.value.map((item) => ({
      text: root.$t(item.key),
      value: item.id
    })));

    const onShow = () => {
      storage.value = asset.value.storageId;
      status.value = asset.value.status;
      expectedAmount.value = asset.value.expectedAmount ? (asset.value.expectedAmount / MILLION).toFixed(3) : '';
      valuatedAmount.value = asset.value.valuatedAmount ? (asset.value.valuatedAmount / MILLION).toFixed(3) : '';
      categoryId.value = asset.value.categoryId;
      description.value = asset.value.description;
      valuator.value = asset.value.valuatedById;
      meta.value = asset.value.meta || {};
      code.value = asset.value.code || '';
      clientName.value = asset.value.client && asset.value.client.nameVi;
      createdAt.value = moment(asset.value.createdAt, DATE_FORMAT).format('DD/MM/YYYY');
      modifiedAt.value = moment(asset.value.modifiedAt, DATE_FORMAT).format('DD/MM/YYYY');
      liquidizedOn.value = asset.value.liquidizedOn && moment(asset.value.liquidizedOn, DATE_FORMAT).format('DD/MM/YYYY');
    };

    const save = async () => {
      try {
        const data = {
          storageId: storage.value,
          status: status.value,
          expectedAmount: expectedAmount.value ? Math.floor(parseFloat(expectedAmount.value) * MILLION) : undefined,
          valuatedAmount: valuatedAmount.value ? Math.floor(parseFloat(valuatedAmount.value * MILLION)) : undefined,
          categoryId: categoryId.value,
          description: description.value,
          valuatedById: valuator.value,
          meta: {
            accessories: accessories.value || undefined,
            brand: brand.value || undefined,
            productLine: productLine.value || undefined,
            chassisId: chassisId.value || undefined,
            engineId: engineId.value || undefined,
            color: color.value || undefined,
            licensePlateId: licensePlateId.value || undefined,
            coOwner: coOwner.value || undefined,
            coOwnerCitizenId: coOwnerCitizenId.value || undefined
          },
          code: code.value || {},
        };
        await updateAsset({ id: asset.value.id, data });
        info('SUCCESSFULLY_UPDATED_ASSET');
        await getAssetsList();

        toggleEditAsset(false);
      } catch (err) {
        error(err);
      }
    };

    const off = () => {
      modal.value.hide();
    };

    const onHide = () => {
      toggleEditAsset(false);
    };

    watch(isOpen, (newVal) => {
      if (newVal) {
        modal.value.show();
      } else modal.value.hide();
    });

    watch(meta, (val) => {
      accessories.value = val.accessories || '';
      brand.value = val.brand || '';
      productLine.value = val.productLine || '';
      chassisId.value = val.chassisId || '';
      engineId.value = val.engineId || '';
      color.value = val.color || '';
      licensePlateId.value = val.licensePlateId || '';
      coOwner.value = val.coOwner || '';
      coOwnerCitizenId.value = val.coOwnerCitizenId || '';
    });

    onMounted(() => {
      getValuators();
    });

    return {
      modal,
      onShow,
      onHide,
      off,
      isMobile,
      faTimes,
      moment,
      description,
      status,
      statusList,
      valuatedAmount,
      removeCommas,
      addCommas,
      changeDigitToViText,
      save,
      expectedAmount,
      categoryId,
      categories,
      valuators,
      isVehicle,
      isRealEstate,
      accessories,
      brand,
      productLine,
      chassisId,
      engineId,
      color,
      licensePlateId,
      coOwner,
      coOwnerCitizenId,
      valuator,
      code,
      clientName,
      createdAt,
      liquidizedOn,
      modifiedAt,
      DATE_FORMAT,
      storages,
      storagesList,
      storage
    };
  },

};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#edit-asset-modal {
  .modal-dialog {
    max-width: 790px;
  }

  .header {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 25px;
    font-weight: bold;
  }

  .body {
    margin-top: 20px;
    margin-bottom: 20px;

    .input-wrapper {
      > .input {
        width: 100%;
        margin-bottom: 20px;
      }
    }

    .input {
      margin-bottom: 15px;
    }

    .btns {
      margin-top: 15px;
      text-align: right;

      .primary-button {
        border-radius: 4px;

        &:first-child {
          margin-right: 15px;
        }
      }
    }

    .display,
    .text-input > input {
      border-radius: 4px;
    }

    .form-select-input {
      width: 100%;
    }
  }
};
</style>
